import { render, staticRenderFns } from "./qapgpz.vue?vue&type=template&id=07b00c04&"
import script from "./qapgpz.vue?vue&type=script&lang=js&"
export * from "./qapgpz.vue?vue&type=script&lang=js&"
import style0 from "./qapgpz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports